import { useMutation } from "react-query";

import axios, { AxiosError } from "axios";

import { PAD_SCENARIO_SERVICE_ADDRESS } from "../../../constants/app.constants";

const API_BASE_URL = `${PAD_SCENARIO_SERVICE_ADDRESS}/api/v1/pad-scenario`;

interface UploadShapefileSurveysParams {
  scenarioId: string;
  file: File;
  idProperty?: string;
}

const uploadShapefileSurveys = async ({
  scenarioId: id,
  file,
  idProperty
}: UploadShapefileSurveysParams) => {
  const formData = new FormData();
  formData.append("file", file);

  if (idProperty) {
    formData.append("idProperty", idProperty);
  }

  const url = `${API_BASE_URL}/${id}/import-stick-surveys`;
  const response = await axios.post<void>(url, formData);
  return response.data;
};

const useUploadShapefileSurveys = () => {
  return useMutation<
    unknown,
    AxiosError<{ error: string; properties?: string[] }>,
    UploadShapefileSurveysParams,
    unknown
  >(uploadShapefileSurveys);
};

export default useUploadShapefileSurveys;
